jQuery( document ).ready(function() {
  jQuery("<a class='moreless-button' href='javascript:void(0);'>Read more</a>").insertAfter(".product-single__description.rte.rte-wrapped");

  jQuery('.moreless-button').click(function() {
    jQuery(this).toggleClass('read-more')
     jQuery('.product-single__description.rte.rte-wrapped .moretext').slideToggle();
    if ($('.moreless-button').text() == "Read more") {
      jQuery(this).text("Read less")
    } else {
      jQuery(this).text("Read more")
    }
  });
});
jQuery(document).on("click","#tabAccordion-accordion .panel.panel-default h4.panel-title",function() {
    jQuery('#tabAccordion-accordion .panel-heading').removeClass("active");
    jQuery(this).closest('.panel-heading').addClass("active");
});
jQuery(document).on("click",".menu-inner .menu-dropdown",function() {
    jQuery('.menu-inner .menu-dropdown').removeClass("menu-active");
    jQuery(this).addClass("menu-active");
});
jQuery( document ).ready(function() {
  jQuery(document).on("click",".back-step , .bt-sidebar__close , .overlay",function() {
      jQuery('.menu-inner .menu-dropdown').removeClass("menu-active");
  });
});
// jQuery(document).ready(function() {
//     jQuery('.tab-pane').hide();
//     jQuery('#tab1').show();
//     jQuery('#tabAccordion li a').on('click', function (e) {
//       e.preventDefault();
//       jQuery('#tabAccordion li a').removeClass('active');
//       jQuery(this).addClass('active');
//       jQuery('.tab-pane').hide();
//       var selectedTab = $(this).attr('href');
//       jQuery(selectedTab).show();
//   });
// });

setTimeout(function(){
    jQuery('#our-products-values').insertAfter('.single-mega-menu');
    jQuery('.single-mega-menu + #our-products-values').show();
    jQuery('#mobileid-data').appendTo('.block-mobile-nav .mobile-nav__item--parent:first-child .mobile-nav__children__inner');  
},3000);

jQuery('.mobile-nav-bar').click(function(){
  setTimeout(function(){
  jQuery('#mobileid-data').appendTo('.block-mobile-nav .mobile-nav__item--parent:first-child .mobile-nav__children__inner');  
     jQuery('#mobileid-data').show();
  },1000);
})
jQuery( ".nav__item__dropdown .our-products .tab-content-wrapper .tab-accordion-content" ).insertAfter( ".block-mobile-nav .right-tabs.tab-content-wrapper div#menutab1" );
jQuery('.download-brochure').insertAfter('.product-single .button--single-cart');